<style >
.flow-box {
  width: 375px;
  text-align: left;
  background: #fff;
  margin-top: 8px;
  padding: 13px 60px 31px 60px;
  margin: 10px ;
  border-radius: 4px;
}
.flow-box .flow-box-name {
  color: #2f2f2f;
  font-size: 16px;
  line-height: 22px;
  margin-bottom: 31px;
}
.flow-box .flow-list {
  display: flex;
}
.flow-box .flow-list .flow-box-left {
  width: 36px;
  padding-top: 3px;
}
.flow-box .flow-list .flow-box-left .flow-line-no {
  width: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.flow-box .flow-list .flow-box-left .flow-line-no .flow-line-top {
  margin-bottom: 3px;
}
.flow-box .flow-list .flow-box-left .flow-line-no .flow-line-top img {
  width: 20px;
  height: 20px;
}
.flow-box .flow-list .flow-box-left .flow-line-no .flow-line-top .flow-unpass {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #c5cad5;
}
.flow-box .flow-list .flow-box-left .flow-line-no .flow-line-line {
  width: 1px;
  min-height: 63px;
  background: #c5cad5;
}
.flow-box .flow-list .flow-box-left .flow-line-no .active-line {
  background: #4fa1a4 !important;
}
.flow-box .flow-list .flow-box-right {
  width: 100%;
}
.flow-box .flow-list .flow-box-right .flow-person {
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  color: #323233;
  line-height: 22px;
}
.flow-box .flow-list .flow-box-right .flow-person .flow-approve {
  font-size: 12px;
  margin-left: 8px;
}
.flow-box .flow-list .flow-box-right .flow-person .flow-state-Y {
  color: #4fa1a4;
}
.flow-box .flow-list .flow-box-right .flow-person .flow-state-R {
  color: #ff5555 !important;
}
.flow-box .flow-list .flow-box-right .flow-person .flow-approver {
  color: #bababa;
  display: inline-block;
  width: 50px;
  flex-shrink: 0;
}
.flow-box .flow-list .flow-box-right .flow-position {
  font-size: 14px;
  color: #bababa;
  line-height: 20px;
  margin-top: 4px;
  /* text-align: left; */
}
.flow-box .flow-list .flow-box-right .flow-state-red {
  color: #ff5555 !important;
}
.flow-box .flow-last-list:last-child .flow-line-line {
  display: none !important;
}
  .flow-state-Y {
    background: #E3F0F0;
    padding: 1px 6px;
    border-radius: 3px
  }
  .flow-state-R{
     background: #FFE8EA;
    padding: 1px 6px;
    border-radius: 3px

  }
  .time{
    color:#86909C;
  }
</style>
<template >
  <div class="flow-box">
    <p class="fontC-red" v-if="approvalList&&approvalList.length<1">没有找到规则,请先联系运营人员设置当前部门的流程规则</p>
    <div :class="carbonName ? 'flow-list' : 'flow-list flow-last-list'" v-for="(item, index) in approvalList" :key="index">
      <div class="flow-box-left">
        <div class="flow-line-no">
          <div class="flow-line-top">
            <div class="flow-unpass" v-if="(item.nodeState == 'N' || item.nodeState == 'A') && approveState !== 'Y'"></div>
            <img class="" v-if="item.nodeState == 'R'" src="../assets/images/meeting_R.png" alt="" />
            <img class="" v-if="item.nodeState == 'Y' || approveState == 'Y'" src="../assets/images/meeting_Y.png" alt="" />
          </div>
          <div :class="
              item.nodeState == 'Y' || approveState == 'Y'
                ? 'flow-line-line active-line'
                : 'flow-line-line'
            "></div>
        </div>
      </div>
      <!-- <div class="flow-box-right">
        <div class="flow-person">
          <span>{{ item.approveStaffName }}
            <span class="flow-approve flow-state-Y" v-if="item.nodeState == 'Y' || approveState == 'Y'">已通过</span>
            <span class="flow-approve flow-state-R" v-if="item.nodeState == 'R'">已驳回</span>
          </span>
          <span class="flow-approver">审批人</span>
        </div>
        <div class="flow-position">{{ item.approveStaffPosition }}</div>
        <div class="flow-position flow-state-red" v-if="item.nodeState == 'R'">{{ item.approveSuggest }}</div>
        <div class="flow-position" style="color: #4fa1a4;" v-if="item.nodeState == 'Y'">{{ item.approveSuggest }}</div>
      </div> -->
         <div class="flow-box-right">
            <div class="flow-person">
                <span>{{'审批人-'+item.approveStaffName}}</span> 
                <span class="flow-approve flow-state-Y" v-if="item.nodeState == 'Y'||approveState == 'Y'">已通过</span>
                <span class="flow-approve flow-state-R" v-if="item.nodeState == 'R'">已驳回</span>
            </div>
            <div class="flow-position" style="color:#323233;margin-top:10px;" >{{ item.approveSuggest}}</div>
            <div class="time" style="margin-top:4px;"  v-if="item.nodeState == 'Y'||item.nodeState == 'R'">{{item.updateTime | getTimeDate}}</div>
          </div>
    
    </div>
    <div class="flow-list" v-if="carbonName">
      <div class="flow-box-left">
        <div class="flow-line-no">
          <div class="flow-line-top">
            <div class="flow-unpass" v-if="approveState !== 'Y'"></div>
            <img class="" v-if="approveState == 'Y'" src="../assets/images/meeting_Y.png" alt="" />
          </div>
          <!-- <div class="flow-line-line"></div> -->
        </div>
      </div>
       <div class="flow-box-right">
             <div class="flow-person">
                <span>{{carbonName?'抄送人-'+ carbonName:'暂无抄送人'}}</span> 
                <span class="flow-approve flow-state-Y" v-if="approveState == 'Y'">已抄送</span>
            </div>
            <div class="time" style="margin-top:4px;"  v-if="approveState == 'Y'">{{approvalList[0].updateTime | getTimeDate}}</div>
        </div>
    </div>
    <!-- <icon type="success"></icon> -->
  </div>
</template>
<script>
  export default {
    props: {
      approvalList: {
        type: Array,
        default() {
          return [];
        }
      },
      carbonName: {
        type: String,
        default() {
          return '';
        }
      },
      approveState: {
        type: String,
        default() {
          return 'N';
        }
      },
    },
    data() {
      return {
        //   carbonName:'',
        //   approvalList:[],
        //   approvalState:''
      }
    },
    mounted(){
    }
  }
</script>